export default __webpack_public_path__ + "static/media/leftArrowButton.f1603837.svg";